














































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import NumberStepper from '@/components/Views/Cart/NumberStepper.vue';
import {Mixins} from 'vue-property-decorator';
import CurrencyMixin from '@/mixins/CurrencyMixin.vue';
import {Call, Sync} from 'vuex-pathify';
import {nil} from '@/common';
import {DateTime} from 'luxon';

@Component({
    components: {
        NumberStepper,
    },
})
export default class ServiceLineItem extends Mixins(CurrencyMixin) {
    @Sync('booking/durations') public durations!: number[];
    @Call('booking/setDurations') public setDurations!: (durations: number[]) => number[];
    @Sync('booking/guests') public guests!: number[];

    @Prop({default: undefined})
    public service!: any;

    @Prop({default: undefined})
    public vendor!: any;

    @Prop({default: 0})
    public serviceIndex!: number;

    @Prop({default: ''})
    public date!: string;

    @Prop({default: '12'})
    public hour!: string;

    private showHourAdjustment = false;
    @Watch('showHourAdjustment')
    public onPropChanged(value: boolean, oldValue: boolean) {
        if (!value) {
            const copy = JSON.parse(JSON.stringify(this.durations));
            copy[this.serviceIndex] = 1;
            this.setDurations(copy);
        }
    }


    public mounted() {
        if (this.durations[this.serviceIndex] > 1) {
            this.showHourAdjustment = true;
        }
    }
    get duration(){
        return this.durations[this.serviceIndex]
    }
    get guestCount(){
        return this.guests[this.serviceIndex];
    }
    get bookingSplit(){
        const split = this.guestCount / this.duration;
        return split <= this.service.hourlyLimit ? 1 : Math.ceil(split/this.service.hourlyLimit);
    }
    get vendorDetails() {
        return nil(this.vendor) ? 'A pro will be chosen for you' : `You have requested ${this.vendor.firstName}`;
    }

    get servicePrice() {
        return this.priceDisplay(this.calculateServicePrice(this.service.price, this.duration, this.guestCount));
    }
    get hasImages() {
        return !nil(this.service.imageModels, true);
    }
    get imageStyle() {
        // return `background-image:url("../img/services/${this.service._id}.jpg"),url("../img/services/${this.service._id}.jpg");background-color:rgba(0,0,0,0.4)`;
        // return `background-image:url("/img/serviceTypes/hair.jpeg");background-color:rgba(0,0,0,0.4)`;
        return !this.hasImages ? '' : `background-image:url('${this.service.imageModels[0].file}');`;
    }
    get formattedDate() {
        return `${DateTime.fromISO(this.date).toFormat('DDDD')} at ${DateTime.fromFormat(this.hour, 'HH:mm').toFormat('h:mm a')}`;
    }
}
